import { useDebounceFn } from '@vueuse/core';
import { defineStore } from 'pinia';
import {
  computed,
  nextTick,
  ref,
} from 'vue';

import { fullLog } from '@/shared/lib';

export const useCitiesDADATAStore = defineStore('citiesDADATA', () => {
  const { DADATA_TOKEN } = process.env;

  const dataCity = ref<Array<string>>([]);
  const isLoading = ref(false);
  const token = computed(() => `Token ${ DADATA_TOKEN }`);

  function findCityInList (value: string, strict = true) {
    if (strict) {
      return dataCity.value.find((title) => title === value);
    }

    return dataCity.value.find((title) => title.toLowerCase() === value.toLowerCase());
  }

  const onInputDebounced
    = useDebounceFn((searchString) => {
      if (searchString) {
        sendRequestCity(searchString).then(() => {
          nextTick(() => {
            const found = findCityInList(searchString, false);

            if (found) {
              searchString = found;
            }
          });
        });
      }
    }, 500);

  async function sendRequestCity (query: string) {
    isLoading.value = true;
    try {
      const options: RequestInit = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': token.value,
        },

        body: JSON.stringify({
          query,
          from_bound: { value: 'city' },
          to_bound: { value: 'city' },
        }),
      };
      const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';
      const data = await fetch(url, options);
      const { suggestions } = await data.json();
      dataCity.value = [
        ...new Set(
          suggestions
            ?.map((el: { data: { city: string } }) => el?.data.city)
            .filter((el: string) => el) ?? [],
        ).values(),
      ] as Array<string>;
    } catch (error) {
      fullLog(error, '🚀 ~ file: FormFieldCity.vue ~ ~ sendRequestCity ~ error');
    } finally {
      isLoading.value = false;
    }
  }

  return {
    dataCity,
    sendRequestCity,
    onInputDebounced,
    findCityInList,
  };
});
